<template>
  <el-dialog :visible.sync="visible" title="发送红包" width="420px" @close="onClose">
  <el-form :model="form" :rules="rules" ref="form" label-width="90px">
      <el-form-item label="红包类型" prop="splitType">
        <el-radio-group v-if="chatType !== 1" v-model="form.splitType">
          <el-radio :label="1">普通红包(均分)</el-radio>
          <el-radio :label="2">拼手气(随机)</el-radio>
        </el-radio-group>
        <div v-else class="fixed-type">普通红包(均分)</div>
      </el-form-item>
      <el-form-item label="总金额" prop="totalAmountYuan">
        <el-input v-model.number="form.totalAmountYuan" type="number" step="0.01" min="0.01" placeholder="单位：元" />
      </el-form-item>
      <el-form-item label="份数" prop="totalCount">
        <el-input-number v-if="chatType !== 1" v-model.number="form.totalCount" :min="1" :max="maxCount || undefined" />
        <div v-else class="fixed-count">1</div>
      </el-form-item>
      <el-form-item label="祝福语" prop="greeting">
        <el-input v-model="form.greeting" placeholder="恭喜发财，大吉大利" />
      </el-form-item>
      <el-form-item label="支付密码" prop="payPwd">
        <el-input v-model="form.payPwd" show-password placeholder="请输入支付密码" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible=false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">发送</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RedPacketSendDialog',
  props: {
    chatType: { type: Number, required: true },
    targetId: { type: Number, required: true },
    groupSize: { type: Number, default: 0 }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        splitType: 1,
        totalAmountYuan: null,
        totalCount: 1,
        greeting: '',
        payPwd: ''
      },
      rules: {
        splitType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        totalAmountYuan: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        totalCount: [{ required: true, message: '请输入份数', trigger: 'change' }],
        payPwd: [{ required: true, message: '请输入支付密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open() {
      if (this.chatType === 1) {
        this.form.splitType = 1;
        this.form.totalCount = 1;
      }
      this.visible = true;
    },
    onClose() { this.$refs.form && this.$refs.form.resetFields(); },
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        if (!(this.form.totalAmountYuan > 0) || !(this.form.totalCount > 0)) {
          this.$message.error('金额或数量不合法');
          return;
        }
        const totalAmount = Math.round(this.form.totalAmountYuan * 100);
        if (totalAmount < this.form.totalCount) {
          this.$message.error('金额或数量不合法');
          return;
        }
        const maxCount = this.chatType === 1 ? 1 : (this.groupSize || 0);
        if (this.chatType === 1 && this.form.totalCount !== 1) {
          this.$message.error('单聊红包份数必须为1');
          return;
        }
        if (this.chatType === 1 && this.form.splitType !== 1) {
          this.$message.error('单聊仅支持普通红包');
          return;
        }
        if (this.chatType === 2 && maxCount > 0 && this.form.totalCount > maxCount) {
          this.$message.error(`群聊红包份数最多${maxCount}份`);
          return;
        }
        const dto = {
          chatType: this.chatType,
          targetId: this.targetId,
          splitType: this.form.splitType,
          totalAmount,
          totalCount: this.form.totalCount,
          greeting: this.form.greeting,
          payPwd: this.form.payPwd
        };
        this.loading = true;
        try {
          const url = this.chatType === 1 ? '/redEnvelope/send/private' : '/redEnvelope/send/group';
          const envelope = await this.$http({ url, method: 'POST', data: dto });
          this.$message.success('红包已发送');
          const brief = {
            id: envelope.id,
            greeting: envelope.greeting,
            totalAmount: envelope.totalAmount,
            totalCount: envelope.totalCount,
            remainAmount: envelope.remainAmount,
            remainCount: envelope.remainCount,
            status: envelope.status
          };
          const msgInfo = {
            tmpId: String(Date.now()) + String(Math.floor(Math.random() * 1000)),
            sendTime: new Date().getTime(),
            type: this.$enums.MESSAGE_TYPE.RED_PACKET,
            content: JSON.stringify(brief),
            selfSend: true,
            status: this.$enums.MESSAGE_STATUS.DELIVERED,
            sendId: this.userStore.userInfo.id
          };
          const chatInfo = { type: this.chatType === 1 ? 'PRIVATE' : 'GROUP', targetId: this.targetId };
          if (this.chatType === 1) {
            msgInfo.recvId = this.targetId;
          } else {
            msgInfo.groupId = this.targetId;
          }
          this.chatStore.insertMessage(msgInfo, chatInfo);
          this.visible = false;
        } catch (e) {
          let _ = e;
        } finally {
          this.loading = false;
        }
      })
    }
  }
  ,computed: {
    maxCount() {
      if (this.chatType === 1) return 1;
      const store = require('../../store/groupStore.js').default();
      const group = store.findGroup(this.targetId);
      const sizeFromStore = group && Array.isArray(group.members) ? group.members.length : 0;
      if (this.groupSize && this.groupSize > 0) return this.groupSize;
      if (sizeFromStore > 0) return sizeFromStore;
      return 1;
    }
  }
}
</script>

<style scoped>
.dialog-footer { text-align: right; }
.fixed-type { padding: 6px 8px; color: #606266; }
.fixed-count { padding: 6px 8px; color: #606266; }
</style>
